let host = window.location.protocol + '//'+window.location.host.replace(/^\w+\./, process.env.env + 'web.')+'/';
let socket = host.replace(/^http/i,'ws')
let previewUrl = "http://file-online-preview.ops.lztongxing.cn"; // 线上地址

// ws://prdweb.zjkaixi.cn/webSocket/
// ws://uatweb.zjkaixi.cn/webSocket/
// ws://sitweb.second-brain.com.cn/webSocket/
let socketWs = 'wss';

if(host.indexOf('http://')==0){
    socketWs = 'ws';
}


if(process.env.env === 'sit'){
  socket = socketWs+'://sitweb.second-brain.com.cn/'
}
if(process.env.env === 'uat'){
    socket = socketWs+'://uatweb.zjkaixi.cn/'
}
if(process.env.env === 'prd'){
    socket = socketWs+'://prdweb.zjkaixi.cn/'
}

if(process.env.env === 'local'){
    try{
        let localConfig = require('./index-private.js').default;
        host = localConfig.host;
        socket = localConfig.socket;
        console.log({host});
    }catch (e){
        console.warn('!!! 开发环境无本地配置, 将使用默认配置');
    }
}
export const rootUrl = host + 'client/';
export const socketUrl = socket + 'webSocket/';
export const onlinePreviewUrl = previewUrl;


/*
 ========== index-private.js ============
 export default {
    host:`http://local.lztongxing.cn:82/sit/`
}
*/


// WEBPACK FOOTER //
// ./src/config/index.js